module.exports = __webpack_public_path__ + "img/case-connection-reuse.797dc440.png";